module.exports = __webpack_public_path__ + "static/media/theme-dark.f03ffff2.png";